import { ChevronDown, ChevronUp } from "lucide-react";

const ProgramOutcomes = ({ outcomes, isExpanded, onToggle, darkMode }) => {
  return (
    <div className="mb-4">
      <div className="flex items-center cursor-pointer mb-2" onClick={onToggle}>
        <h4
          className={`text-base font-semibold ${
            darkMode ? "text-white" : "text-gray-700"
          }`}
        >
          Program Outcomes
        </h4>
        {isExpanded ? (
          <ChevronUp
            size={16}
            className={`ml-2 ${darkMode ? "text-gray-400" : "text-gray-500"}`}
          />
        ) : (
          <ChevronDown
            size={16}
            className={`ml-2 ${darkMode ? "text-gray-400" : "text-gray-500"}`}
          />
        )}
      </div>

      {isExpanded && (
        <div className="space-y-2">
          {outcomes.length > 0 ? (
            outcomes.map((po) => (
              <div
                key={po.po_number}
                className={`p-2 rounded ${
                  darkMode ? "bg-[#161B22]" : "bg-gray-50"
                }`}
              >
                <p
                  className={`text-sm font-medium ${
                    darkMode ? "text-white" : "text-gray-800"
                  }`}
                >
                  <span className="font-semibold">{po.po_number}:</span>{" "}
                  {po.po_description}
                </p>
              </div>
            ))
          ) : (
            <p
              className={`text-xs ${
                darkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              No program outcomes defined yet.
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default ProgramOutcomes;
